import { useSelector } from 'react-redux';

const useCanMarkOrderAsUncollected = (): boolean => {
  const { user } = useSelector((state: any) => state.user);
  const permissionValue = user?.permission?.markOrderAsUncollected?.canMutate;

  return permissionValue !== false;
};

export default useCanMarkOrderAsUncollected;
